/**
 * Registry central des générateurs d'exercices.
 * Map attendu_id → { generate, categories }
 *
 * FICHIER GÉNÉRÉ par scripts/gen-registry.js — ne pas éditer les imports à la
 * main : `npm run registry:gen` après ajout/suppression d'un gen_<id>.js.
 * (gen_patron.js et gen_demo_angle.js sont exclus d'office par le scan.)
 *
 * Chaque générateur retourne un payload au format BanqueQuestion standard.
 */

import { nettoyerErreurs } from './erreursNommables';

// --- nombres (136-1220) ---
import { generate as gen136, CATEGORIES as cats136 } from './maths/4eme/nombres/gen_136';
import { generate as gen137, CATEGORIES as cats137 } from './maths/4eme/nombres/gen_137';
import { generate as gen138, CATEGORIES as cats138 } from './maths/4eme/nombres/gen_138';
import { generate as gen139, CATEGORIES as cats139 } from './maths/4eme/nombres/gen_139';
import { generate as gen140, CATEGORIES as cats140 } from './maths/4eme/nombres/gen_140';
import { generate as gen141, CATEGORIES as cats141 } from './maths/4eme/nombres/gen_141';
import { generate as gen142, CATEGORIES as cats142 } from './maths/4eme/nombres/gen_142';
import { generate as gen143, CATEGORIES as cats143 } from './maths/4eme/nombres/gen_143';
import { generate as gen144, CATEGORIES as cats144 } from './maths/4eme/nombres/gen_144';
import { generate as gen145, CATEGORIES as cats145 } from './maths/4eme/nombres/gen_145';
import { generate as gen146, CATEGORIES as cats146 } from './maths/4eme/nombres/gen_146';
import { generate as gen147, CATEGORIES as cats147 } from './maths/4eme/nombres/gen_147';
import { generate as gen148, CATEGORIES as cats148 } from './maths/4eme/nombres/gen_148';
import { generate as gen149, CATEGORIES as cats149 } from './maths/4eme/nombres/gen_149';
import { generate as gen150, CATEGORIES as cats150 } from './maths/4eme/nombres/gen_150';
import { generate as gen151, CATEGORIES as cats151 } from './maths/4eme/nombres/gen_151';
import { generate as gen152, CATEGORIES as cats152 } from './maths/4eme/nombres/gen_152';
// --- divisibilite (153-1224) ---
import { generate as gen153, CATEGORIES as cats153 } from './maths/4eme/divisibilite/gen_153';
import { generate as gen154, CATEGORIES as cats154 } from './maths/4eme/divisibilite/gen_154';
import { generate as gen155, CATEGORIES as cats155 } from './maths/4eme/divisibilite/gen_155';
import { generate as gen156, CATEGORIES as cats156 } from './maths/4eme/divisibilite/gen_156';
import { generate as gen157, CATEGORIES as cats157 } from './maths/4eme/divisibilite/gen_157';
// --- calcul-litteral (158-1233) ---
import { generate as gen158, CATEGORIES as cats158 } from './maths/4eme/calcul-litteral/gen_158';
import { generate as gen159, CATEGORIES as cats159 } from './maths/4eme/calcul-litteral/gen_159';
import { generate as gen160, CATEGORIES as cats160 } from './maths/4eme/calcul-litteral/gen_160';
import { generate as gen161, CATEGORIES as cats161 } from './maths/4eme/calcul-litteral/gen_161';
import { generate as gen162, CATEGORIES as cats162 } from './maths/4eme/calcul-litteral/gen_162';
import { generate as gen163, CATEGORIES as cats163 } from './maths/4eme/calcul-litteral/gen_163';
// --- donnees (164-1248) ---
import { generate as gen164, CATEGORIES as cats164 } from './maths/4eme/donnees/gen_164';
import { generate as gen165, CATEGORIES as cats165 } from './maths/4eme/donnees/gen_165';
// --- probabilites (166-1083) ---
import { generate as gen166, CATEGORIES as cats166 } from './maths/4eme/probabilites/gen_166';
import { generate as gen167, CATEGORIES as cats167 } from './maths/4eme/probabilites/gen_167';
import { generate as gen168, CATEGORIES as cats168 } from './maths/4eme/probabilites/gen_168';
import { generate as gen169, CATEGORIES as cats169 } from './maths/4eme/probabilites/gen_169';
import { generate as gen170, CATEGORIES as cats170 } from './maths/4eme/probabilites/gen_170';
// --- proportionnalite (171-1254) ---
import { generate as gen171, CATEGORIES as cats171 } from './maths/4eme/proportionnalite/gen_171';
import { generate as gen172, CATEGORIES as cats172 } from './maths/4eme/proportionnalite/gen_172';
import { generate as gen173, CATEGORIES as cats173 } from './maths/4eme/proportionnalite/gen_173';
import { generate as gen174, CATEGORIES as cats174 } from './maths/4eme/proportionnalite/gen_174';
// --- fonctions (175-995) ---
import { generate as gen175, CATEGORIES as cats175 } from './maths/4eme/fonctions/gen_175';
import { generate as gen176, CATEGORIES as cats176 } from './maths/4eme/fonctions/gen_176';
import { generate as gen177, CATEGORIES as cats177 } from './maths/4eme/fonctions/gen_177';
// --- grandeurs (178-1245) ---
import { generate as gen178, CATEGORIES as cats178 } from './maths/4eme/grandeurs/gen_178';
import { generate as gen179, CATEGORIES as cats179 } from './maths/4eme/grandeurs/gen_179';
// --- transformations (180-1121) ---
import { generate as gen180, CATEGORIES as cats180 } from './maths/4eme/transformations/gen_180';
import { generate as gen181, CATEGORIES as cats181 } from './maths/4eme/transformations/gen_181';
import { generate as gen182, CATEGORIES as cats182 } from './maths/4eme/transformations/gen_182';
// --- espace (183-1240) ---
import { generate as gen183, CATEGORIES as cats183 } from './maths/4eme/espace/gen_183';
import { generate as gen184, CATEGORIES as cats184 } from './maths/4eme/espace/gen_184';
import { generate as gen185, CATEGORIES as cats185 } from './maths/4eme/espace/gen_185';
// --- geometrie-plane (186-1244) ---
import { generate as gen186, CATEGORIES as cats186 } from './maths/4eme/geometrie-plane/gen_186';
import { generate as gen187, CATEGORIES as cats187 } from './maths/4eme/geometrie-plane/gen_187';
import { generate as gen188, CATEGORIES as cats188 } from './maths/4eme/geometrie-plane/gen_188';
import { generate as gen189, CATEGORIES as cats189 } from './maths/4eme/geometrie-plane/gen_189';
import { generate as gen190, CATEGORIES as cats190 } from './maths/4eme/geometrie-plane/gen_190';
// --- algorithmique (191-690) ---
import { generate as gen191, CATEGORIES as cats191 } from './maths/4eme/algorithmique/gen_191';
import { generate as gen192, CATEGORIES as cats192 } from './maths/4eme/algorithmique/gen_192';
import { generate as gen193, CATEGORIES as cats193 } from './maths/4eme/algorithmique/gen_193';
import { generate as gen194, CATEGORIES as cats194 } from './maths/4eme/algorithmique/gen_194';
import { generate as gen195, CATEGORIES as cats195 } from './maths/4eme/algorithmique/gen_195';
import { generate as gen196, CATEGORIES as cats196 } from './maths/4eme/algorithmique/gen_196';
import { generate as gen197, CATEGORIES as cats197 } from './maths/4eme/algorithmique/gen_197';
import { generate as gen198, CATEGORIES as cats198 } from './maths/4eme/algorithmique/gen_198';
import { generate as gen199, CATEGORIES as cats199 } from './maths/4eme/algorithmique/gen_199';
import { generate as gen200, CATEGORIES as cats200 } from './maths/4eme/algorithmique/gen_200';
// --- nombres (136-1220) ---
import { generate as gen201, CATEGORIES as cats201 } from './maths/3eme/nombres/gen_201';
import { generate as gen202, CATEGORIES as cats202 } from './maths/3eme/nombres/gen_202';
import { generate as gen203, CATEGORIES as cats203 } from './maths/3eme/nombres/gen_203';
import { generate as gen204, CATEGORIES as cats204 } from './maths/3eme/nombres/gen_204';
// --- divisibilite (153-1224) ---
import { generate as gen205, CATEGORIES as cats205 } from './maths/3eme/divisibilite/gen_205';
import { generate as gen206, CATEGORIES as cats206 } from './maths/3eme/divisibilite/gen_206';
import { generate as gen207, CATEGORIES as cats207 } from './maths/3eme/divisibilite/gen_207';
// --- calcul-litteral (158-1233) ---
import { generate as gen208, CATEGORIES as cats208 } from './maths/3eme/calcul-litteral/gen_208';
import { generate as gen209, CATEGORIES as cats209 } from './maths/3eme/calcul-litteral/gen_209';
import { generate as gen210, CATEGORIES as cats210 } from './maths/3eme/calcul-litteral/gen_210';
import { generate as gen211, CATEGORIES as cats211 } from './maths/3eme/calcul-litteral/gen_211';
import { generate as gen212, CATEGORIES as cats212 } from './maths/3eme/calcul-litteral/gen_212';
// --- donnees (164-1248) ---
import { generate as gen213, CATEGORIES as cats213 } from './maths/3eme/donnees/gen_213';
import { generate as gen214, CATEGORIES as cats214 } from './maths/3eme/donnees/gen_214';
import { generate as gen215, CATEGORIES as cats215 } from './maths/3eme/donnees/gen_215';
// --- probabilites (166-1083) ---
import { generate as gen216, CATEGORIES as cats216 } from './maths/3eme/probabilites/gen_216';
import { generate as gen217, CATEGORIES as cats217 } from './maths/3eme/probabilites/gen_217';
// --- proportionnalite (171-1254) ---
import { generate as gen218, CATEGORIES as cats218 } from './maths/3eme/proportionnalite/gen_218';
import { generate as gen219, CATEGORIES as cats219 } from './maths/3eme/proportionnalite/gen_219';
import { generate as gen220, CATEGORIES as cats220 } from './maths/3eme/proportionnalite/gen_220';
// --- fonctions (175-995) ---
import { generate as gen221, CATEGORIES as cats221 } from './maths/3eme/fonctions/gen_221';
import { generate as gen222, CATEGORIES as cats222 } from './maths/3eme/fonctions/gen_222';
import { generate as gen223, CATEGORIES as cats223 } from './maths/3eme/fonctions/gen_223';
import { generate as gen224, CATEGORIES as cats224 } from './maths/3eme/fonctions/gen_224';
import { generate as gen225, CATEGORIES as cats225 } from './maths/3eme/fonctions/gen_225';
import { generate as gen226, CATEGORIES as cats226 } from './maths/3eme/fonctions/gen_226';
import { generate as gen227, CATEGORIES as cats227 } from './maths/3eme/fonctions/gen_227';
import { generate as gen228, CATEGORIES as cats228 } from './maths/3eme/fonctions/gen_228';
import { generate as gen229, CATEGORIES as cats229 } from './maths/3eme/fonctions/gen_229';
import { generate as gen230, CATEGORIES as cats230 } from './maths/3eme/fonctions/gen_230';
// --- grandeurs (178-1245) ---
import { generate as gen231, CATEGORIES as cats231 } from './maths/3eme/grandeurs/gen_231';
import { generate as gen232, CATEGORIES as cats232 } from './maths/3eme/grandeurs/gen_232';
import { generate as gen233, CATEGORIES as cats233 } from './maths/3eme/grandeurs/gen_233';
import { generate as gen234, CATEGORIES as cats234 } from './maths/3eme/grandeurs/gen_234';
import { generate as gen235, CATEGORIES as cats235 } from './maths/3eme/grandeurs/gen_235';
// --- transformations (180-1121) ---
import { generate as gen236, CATEGORIES as cats236 } from './maths/3eme/transformations/gen_236';
import { generate as gen237, CATEGORIES as cats237 } from './maths/3eme/transformations/gen_237';
// --- espace (183-1240) ---
import { generate as gen238, CATEGORIES as cats238 } from './maths/3eme/espace/gen_238';
import { generate as gen239, CATEGORIES as cats239 } from './maths/3eme/espace/gen_239';
// --- geometrie-plane (186-1244) ---
import { generate as gen240, CATEGORIES as cats240 } from './maths/3eme/geometrie-plane/gen_240';
import { generate as gen241, CATEGORIES as cats241 } from './maths/3eme/geometrie-plane/gen_241';
import { generate as gen242, CATEGORIES as cats242 } from './maths/3eme/geometrie-plane/gen_242';
import { generate as gen243, CATEGORIES as cats243 } from './maths/3eme/geometrie-plane/gen_243';
// --- algorithmique (191-690) ---
import { generate as gen244, CATEGORIES as cats244 } from './maths/3eme/algorithmique/gen_244';
import { generate as gen245, CATEGORIES as cats245 } from './maths/3eme/algorithmique/gen_245';
import { generate as gen246, CATEGORIES as cats246 } from './maths/3eme/algorithmique/gen_246';
import { generate as gen247, CATEGORIES as cats247 } from './maths/3eme/algorithmique/gen_247';
import { generate as gen248, CATEGORIES as cats248 } from './maths/3eme/algorithmique/gen_248';
import { generate as gen249, CATEGORIES as cats249 } from './maths/3eme/algorithmique/gen_249';
import { generate as gen250, CATEGORIES as cats250 } from './maths/3eme/algorithmique/gen_250';
import { generate as gen251, CATEGORIES as cats251 } from './maths/3eme/algorithmique/gen_251';
import { generate as gen252, CATEGORIES as cats252 } from './maths/3eme/algorithmique/gen_252';
import { generate as gen253, CATEGORIES as cats253 } from './maths/3eme/algorithmique/gen_253';
// --- nombres-decimaux (596-1014) ---
import { generate as gen596, CATEGORIES as cats596 } from './maths/6eme/nombres-decimaux/gen_596';
import { generate as gen597, CATEGORIES as cats597 } from './maths/6eme/nombres-decimaux/gen_597';
import { generate as gen598, CATEGORIES as cats598 } from './maths/6eme/nombres-decimaux/gen_598';
import { generate as gen599, CATEGORIES as cats599 } from './maths/6eme/nombres-decimaux/gen_599';
import { generate as gen600, CATEGORIES as cats600 } from './maths/6eme/nombres-decimaux/gen_600';
import { generate as gen601, CATEGORIES as cats601 } from './maths/6eme/nombres-decimaux/gen_601';
import { generate as gen602, CATEGORIES as cats602 } from './maths/6eme/nombres-decimaux/gen_602';
import { generate as gen603, CATEGORIES as cats603 } from './maths/6eme/nombres-decimaux/gen_603';
import { generate as gen604, CATEGORIES as cats604 } from './maths/6eme/nombres-decimaux/gen_604';
import { generate as gen605, CATEGORIES as cats605 } from './maths/6eme/nombres-decimaux/gen_605';
import { generate as gen606, CATEGORIES as cats606 } from './maths/6eme/nombres-decimaux/gen_606';
import { generate as gen607, CATEGORIES as cats607 } from './maths/6eme/nombres-decimaux/gen_607';
import { generate as gen608, CATEGORIES as cats608 } from './maths/6eme/nombres-decimaux/gen_608';
import { generate as gen609, CATEGORIES as cats609 } from './maths/6eme/nombres-decimaux/gen_609';
import { generate as gen610, CATEGORIES as cats610 } from './maths/6eme/nombres-decimaux/gen_610';
import { generate as gen611, CATEGORIES as cats611 } from './maths/6eme/nombres-decimaux/gen_611';
import { generate as gen612, CATEGORIES as cats612 } from './maths/6eme/nombres-decimaux/gen_612';
import { generate as gen613, CATEGORIES as cats613 } from './maths/6eme/nombres-decimaux/gen_613';
import { generate as gen614, CATEGORIES as cats614 } from './maths/6eme/nombres-decimaux/gen_614';
import { generate as gen615, CATEGORIES as cats615 } from './maths/6eme/nombres-decimaux/gen_615';
import { generate as gen616, CATEGORIES as cats616 } from './maths/6eme/nombres-decimaux/gen_616';
import { generate as gen617, CATEGORIES as cats617 } from './maths/6eme/nombres-decimaux/gen_617';
import { generate as gen618, CATEGORIES as cats618 } from './maths/6eme/nombres-decimaux/gen_618';
import { generate as gen619, CATEGORIES as cats619 } from './maths/6eme/nombres-decimaux/gen_619';
// --- fractions (620-636) ---
import { generate as gen620, CATEGORIES as cats620 } from './maths/6eme/fractions/gen_620';
import { generate as gen621, CATEGORIES as cats621 } from './maths/6eme/fractions/gen_621';
import { generate as gen622, CATEGORIES as cats622 } from './maths/6eme/fractions/gen_622';
import { generate as gen623, CATEGORIES as cats623 } from './maths/6eme/fractions/gen_623';
import { generate as gen624, CATEGORIES as cats624 } from './maths/6eme/fractions/gen_624';
import { generate as gen625, CATEGORIES as cats625 } from './maths/6eme/fractions/gen_625';
import { generate as gen626, CATEGORIES as cats626 } from './maths/6eme/fractions/gen_626';
import { generate as gen627, CATEGORIES as cats627 } from './maths/6eme/fractions/gen_627';
import { generate as gen628, CATEGORIES as cats628 } from './maths/6eme/fractions/gen_628';
import { generate as gen629, CATEGORIES as cats629 } from './maths/6eme/fractions/gen_629';
import { generate as gen630, CATEGORIES as cats630 } from './maths/6eme/fractions/gen_630';
import { generate as gen631, CATEGORIES as cats631 } from './maths/6eme/fractions/gen_631';
import { generate as gen632, CATEGORIES as cats632 } from './maths/6eme/fractions/gen_632';
import { generate as gen633, CATEGORIES as cats633 } from './maths/6eme/fractions/gen_633';
import { generate as gen634, CATEGORIES as cats634 } from './maths/6eme/fractions/gen_634';
import { generate as gen635, CATEGORIES as cats635 } from './maths/6eme/fractions/gen_635';
import { generate as gen636, CATEGORIES as cats636 } from './maths/6eme/fractions/gen_636';
// --- algebre (637-638) ---
import { generate as gen637, CATEGORIES as cats637 } from './maths/6eme/algebre/gen_637';
import { generate as gen638, CATEGORIES as cats638 } from './maths/6eme/algebre/gen_638';
// --- longueurs (639-1024) ---
import { generate as gen639, CATEGORIES as cats639 } from './maths/6eme/longueurs/gen_639';
import { generate as gen640, CATEGORIES as cats640 } from './maths/6eme/longueurs/gen_640';
import { generate as gen641, CATEGORIES as cats641 } from './maths/6eme/longueurs/gen_641';
import { generate as gen642, CATEGORIES as cats642 } from './maths/6eme/longueurs/gen_642';
import { generate as gen643, CATEGORIES as cats643 } from './maths/6eme/longueurs/gen_643';
// --- aires (644-1030) ---
import { generate as gen644, CATEGORIES as cats644 } from './maths/6eme/aires/gen_644';
import { generate as gen645, CATEGORIES as cats645 } from './maths/6eme/aires/gen_645';
import { generate as gen646, CATEGORIES as cats646 } from './maths/6eme/aires/gen_646';
// --- volumes (647-649) ---
import { generate as gen647, CATEGORIES as cats647 } from './maths/6eme/volumes/gen_647';
import { generate as gen648, CATEGORIES as cats648 } from './maths/6eme/volumes/gen_648';
import { generate as gen649, CATEGORIES as cats649 } from './maths/6eme/volumes/gen_649';
// --- durée (650-1035) ---
import { generate as gen650, CATEGORIES as cats650 } from './maths/6eme/durée/gen_650';
import { generate as gen651, CATEGORIES as cats651 } from './maths/6eme/durée/gen_651';
import { generate as gen652, CATEGORIES as cats652 } from './maths/6eme/durée/gen_652';
// --- geometrie (653-1019) ---
import { generate as gen653, CATEGORIES as cats653 } from './maths/6eme/geometrie/gen_653';
import { generate as gen654, CATEGORIES as cats654 } from './maths/6eme/geometrie/gen_654';
import { generate as gen655, CATEGORIES as cats655 } from './maths/6eme/geometrie/gen_655';
import { generate as gen656, CATEGORIES as cats656 } from './maths/6eme/geometrie/gen_656';
import { generate as gen657, CATEGORIES as cats657 } from './maths/6eme/geometrie/gen_657';
import { generate as gen658, CATEGORIES as cats658 } from './maths/6eme/geometrie/gen_658';
import { generate as gen659, CATEGORIES as cats659 } from './maths/6eme/geometrie/gen_659';
import { generate as gen660, CATEGORIES as cats660 } from './maths/6eme/geometrie/gen_660';
import { generate as gen661, CATEGORIES as cats661 } from './maths/6eme/geometrie/gen_661';
import { generate as gen662, CATEGORIES as cats662 } from './maths/6eme/geometrie/gen_662';
import { generate as gen663, CATEGORIES as cats663 } from './maths/6eme/geometrie/gen_663';
import { generate as gen664, CATEGORIES as cats664 } from './maths/6eme/geometrie/gen_664';
import { generate as gen665, CATEGORIES as cats665 } from './maths/6eme/geometrie/gen_665';
import { generate as gen666, CATEGORIES as cats666 } from './maths/6eme/geometrie/gen_666';
import { generate as gen667, CATEGORIES as cats667 } from './maths/6eme/geometrie/gen_667';
import { generate as gen668, CATEGORIES as cats668 } from './maths/6eme/geometrie/gen_668';
import { generate as gen669, CATEGORIES as cats669 } from './maths/6eme/geometrie/gen_669';
import { generate as gen670, CATEGORIES as cats670 } from './maths/6eme/geometrie/gen_670';
import { generate as gen671, CATEGORIES as cats671 } from './maths/6eme/geometrie/gen_671';
import { generate as gen672, CATEGORIES as cats672 } from './maths/6eme/geometrie/gen_672';
import { generate as gen673, CATEGORIES as cats673 } from './maths/6eme/geometrie/gen_673';
import { generate as gen674, CATEGORIES as cats674 } from './maths/6eme/geometrie/gen_674';
// --- ogd (675-1036) ---
import { generate as gen675, CATEGORIES as cats675 } from './maths/6eme/ogd/gen_675';
import { generate as gen676, CATEGORIES as cats676 } from './maths/6eme/ogd/gen_676';
import { generate as gen677, CATEGORIES as cats677 } from './maths/6eme/ogd/gen_677';
import { generate as gen678, CATEGORIES as cats678 } from './maths/6eme/ogd/gen_678';
import { generate as gen679, CATEGORIES as cats679 } from './maths/6eme/ogd/gen_679';
import { generate as gen680, CATEGORIES as cats680 } from './maths/6eme/ogd/gen_680';
import { generate as gen681, CATEGORIES as cats681 } from './maths/6eme/ogd/gen_681';
// --- proportionnalite (171-1254) ---
import { generate as gen682, CATEGORIES as cats682 } from './maths/6eme/proportionnalite/gen_682';
import { generate as gen683, CATEGORIES as cats683 } from './maths/6eme/proportionnalite/gen_683';
import { generate as gen684, CATEGORIES as cats684 } from './maths/6eme/proportionnalite/gen_684';
import { generate as gen685, CATEGORIES as cats685 } from './maths/6eme/proportionnalite/gen_685';
import { generate as gen686, CATEGORIES as cats686 } from './maths/6eme/proportionnalite/gen_686';
// --- algorithmique (191-690) ---
import { generate as gen687, CATEGORIES as cats687 } from './maths/6eme/algorithmique/gen_687';
import { generate as gen688, CATEGORIES as cats688 } from './maths/6eme/algorithmique/gen_688';
import { generate as gen689, CATEGORIES as cats689 } from './maths/6eme/algorithmique/gen_689';
import { generate as gen690, CATEGORIES as cats690 } from './maths/6eme/algorithmique/gen_690';
// --- operations (691-1044) ---
import { generate as gen691, CATEGORIES as cats691 } from './maths/5eme/operations/gen_691';
import { generate as gen692, CATEGORIES as cats692 } from './maths/5eme/operations/gen_692';
import { generate as gen693, CATEGORIES as cats693 } from './maths/5eme/operations/gen_693';
import { generate as gen694, CATEGORIES as cats694 } from './maths/5eme/operations/gen_694';
import { generate as gen695, CATEGORIES as cats695 } from './maths/5eme/operations/gen_695';
import { generate as gen696, CATEGORIES as cats696 } from './maths/5eme/operations/gen_696';
import { generate as gen697, CATEGORIES as cats697 } from './maths/5eme/operations/gen_697';
import { generate as gen698, CATEGORIES as cats698 } from './maths/5eme/operations/gen_698';
import { generate as gen699, CATEGORIES as cats699 } from './maths/5eme/operations/gen_699';
import { generate as gen700, CATEGORIES as cats700 } from './maths/5eme/operations/gen_700';
import { generate as gen701, CATEGORIES as cats701 } from './maths/5eme/operations/gen_701';
// --- nombres-relatifs (702-1096) ---
import { generate as gen702, CATEGORIES as cats702 } from './maths/5eme/nombres-relatifs/gen_702';
import { generate as gen703, CATEGORIES as cats703 } from './maths/5eme/nombres-relatifs/gen_703';
import { generate as gen704, CATEGORIES as cats704 } from './maths/5eme/nombres-relatifs/gen_704';
import { generate as gen705, CATEGORIES as cats705 } from './maths/5eme/nombres-relatifs/gen_705';
import { generate as gen706, CATEGORIES as cats706 } from './maths/5eme/nombres-relatifs/gen_706';
import { generate as gen707, CATEGORIES as cats707 } from './maths/5eme/nombres-relatifs/gen_707';
import { generate as gen708, CATEGORIES as cats708 } from './maths/5eme/nombres-relatifs/gen_708';
import { generate as gen709, CATEGORIES as cats709 } from './maths/5eme/nombres-relatifs/gen_709';
import { generate as gen710, CATEGORIES as cats710 } from './maths/5eme/nombres-relatifs/gen_710';
import { generate as gen711, CATEGORIES as cats711 } from './maths/5eme/nombres-relatifs/gen_711';
import { generate as gen712, CATEGORIES as cats712 } from './maths/5eme/nombres-relatifs/gen_712';
import { generate as gen713, CATEGORIES as cats713 } from './maths/5eme/nombres-relatifs/gen_713';
import { generate as gen714, CATEGORIES as cats714 } from './maths/5eme/nombres-relatifs/gen_714';
// --- operations (691-1044) ---
import { generate as gen899, CATEGORIES as cats899 } from './maths/5eme/operations/gen_899';
import { generate as gen900, CATEGORIES as cats900 } from './maths/5eme/operations/gen_900';
import { generate as gen901, CATEGORIES as cats901 } from './maths/5eme/operations/gen_901';
import { generate as gen902, CATEGORIES as cats902 } from './maths/5eme/operations/gen_902';
import { generate as gen903, CATEGORIES as cats903 } from './maths/5eme/operations/gen_903';
import { generate as gen904, CATEGORIES as cats904 } from './maths/5eme/operations/gen_904';
import { generate as gen905, CATEGORIES as cats905 } from './maths/5eme/operations/gen_905';
import { generate as gen906, CATEGORIES as cats906 } from './maths/5eme/operations/gen_906';
import { generate as gen907, CATEGORIES as cats907 } from './maths/5eme/operations/gen_907';
import { generate as gen908, CATEGORIES as cats908 } from './maths/5eme/operations/gen_908';
import { generate as gen909, CATEGORIES as cats909 } from './maths/5eme/operations/gen_909';
// --- nombres-relatifs (702-1096) ---
import { generate as gen910, CATEGORIES as cats910 } from './maths/5eme/nombres-relatifs/gen_910';
import { generate as gen911, CATEGORIES as cats911 } from './maths/5eme/nombres-relatifs/gen_911';
import { generate as gen912, CATEGORIES as cats912 } from './maths/5eme/nombres-relatifs/gen_912';
import { generate as gen913, CATEGORIES as cats913 } from './maths/5eme/nombres-relatifs/gen_913';
import { generate as gen914, CATEGORIES as cats914 } from './maths/5eme/nombres-relatifs/gen_914';
import { generate as gen915, CATEGORIES as cats915 } from './maths/5eme/nombres-relatifs/gen_915';
import { generate as gen916, CATEGORIES as cats916 } from './maths/5eme/nombres-relatifs/gen_916';
import { generate as gen917, CATEGORIES as cats917 } from './maths/5eme/nombres-relatifs/gen_917';
import { generate as gen918, CATEGORIES as cats918 } from './maths/5eme/nombres-relatifs/gen_918';
import { generate as gen919, CATEGORIES as cats919 } from './maths/5eme/nombres-relatifs/gen_919';
import { generate as gen920, CATEGORIES as cats920 } from './maths/5eme/nombres-relatifs/gen_920';
import { generate as gen921, CATEGORIES as cats921 } from './maths/5eme/nombres-relatifs/gen_921';
import { generate as gen922, CATEGORIES as cats922 } from './maths/5eme/nombres-relatifs/gen_922';
// --- nombres-rationnels (923-1100) ---
import { generate as gen923, CATEGORIES as cats923 } from './maths/5eme/nombres-rationnels/gen_923';
import { generate as gen924, CATEGORIES as cats924 } from './maths/5eme/nombres-rationnels/gen_924';
import { generate as gen925, CATEGORIES as cats925 } from './maths/5eme/nombres-rationnels/gen_925';
// --- puissances (926-1105) ---
import { generate as gen926, CATEGORIES as cats926 } from './maths/5eme/puissances/gen_926';
import { generate as gen927, CATEGORIES as cats927 } from './maths/5eme/puissances/gen_927';
import { generate as gen928, CATEGORIES as cats928 } from './maths/5eme/puissances/gen_928';
import { generate as gen929, CATEGORIES as cats929 } from './maths/5eme/puissances/gen_929';
import { generate as gen930, CATEGORIES as cats930 } from './maths/5eme/puissances/gen_930';
import { generate as gen931, CATEGORIES as cats931 } from './maths/5eme/puissances/gen_931';
// --- calcul-litteral (158-1233) ---
import { generate as gen932, CATEGORIES as cats932 } from './maths/5eme/calcul-litteral/gen_932';
import { generate as gen933, CATEGORIES as cats933 } from './maths/5eme/calcul-litteral/gen_933';
import { generate as gen934, CATEGORIES as cats934 } from './maths/5eme/calcul-litteral/gen_934';
import { generate as gen935, CATEGORIES as cats935 } from './maths/5eme/calcul-litteral/gen_935';
import { generate as gen936, CATEGORIES as cats936 } from './maths/5eme/calcul-litteral/gen_936';
import { generate as gen937, CATEGORIES as cats937 } from './maths/5eme/calcul-litteral/gen_937';
import { generate as gen938, CATEGORIES as cats938 } from './maths/5eme/calcul-litteral/gen_938';
import { generate as gen939, CATEGORIES as cats939 } from './maths/5eme/calcul-litteral/gen_939';
import { generate as gen940, CATEGORIES as cats940 } from './maths/5eme/calcul-litteral/gen_940';
import { generate as gen941, CATEGORIES as cats941 } from './maths/5eme/calcul-litteral/gen_941';
import { generate as gen942, CATEGORIES as cats942 } from './maths/5eme/calcul-litteral/gen_942';
import { generate as gen943, CATEGORIES as cats943 } from './maths/5eme/calcul-litteral/gen_943';
// --- reperage (944-1237) ---
import { generate as gen944, CATEGORIES as cats944 } from './maths/5eme/reperage/gen_944';
import { generate as gen945, CATEGORIES as cats945 } from './maths/5eme/reperage/gen_945';
// --- espace (183-1240) ---
import { generate as gen946, CATEGORIES as cats946 } from './maths/5eme/espace/gen_946';
import { generate as gen947, CATEGORIES as cats947 } from './maths/5eme/espace/gen_947';
import { generate as gen948, CATEGORIES as cats948 } from './maths/5eme/espace/gen_948';
import { generate as gen949, CATEGORIES as cats949 } from './maths/5eme/espace/gen_949';
import { generate as gen950, CATEGORIES as cats950 } from './maths/5eme/espace/gen_950';
// --- transformations (180-1121) ---
import { generate as gen951, CATEGORIES as cats951 } from './maths/5eme/transformations/gen_951';
import { generate as gen952, CATEGORIES as cats952 } from './maths/5eme/transformations/gen_952';
// --- angles (953-1075) ---
import { generate as gen953, CATEGORIES as cats953 } from './maths/5eme/angles/gen_953';
// --- triangles (954-1078) ---
import { generate as gen954, CATEGORIES as cats954 } from './maths/5eme/triangles/gen_954';
import { generate as gen955, CATEGORIES as cats955 } from './maths/5eme/triangles/gen_955';
import { generate as gen956, CATEGORIES as cats956 } from './maths/5eme/triangles/gen_956';
import { generate as gen957, CATEGORIES as cats957 } from './maths/5eme/triangles/gen_957';
import { generate as gen958, CATEGORIES as cats958 } from './maths/5eme/triangles/gen_958';
import { generate as gen959, CATEGORIES as cats959 } from './maths/5eme/triangles/gen_959';
import { generate as gen960, CATEGORIES as cats960 } from './maths/5eme/triangles/gen_960';
import { generate as gen961, CATEGORIES as cats961 } from './maths/5eme/triangles/gen_961';
import { generate as gen962, CATEGORIES as cats962 } from './maths/5eme/triangles/gen_962';
// --- parallelogrammes (963-1080) ---
import { generate as gen963, CATEGORIES as cats963 } from './maths/5eme/parallelogrammes/gen_963';
import { generate as gen964, CATEGORIES as cats964 } from './maths/5eme/parallelogrammes/gen_964';
import { generate as gen965, CATEGORIES as cats965 } from './maths/5eme/parallelogrammes/gen_965';
import { generate as gen966, CATEGORIES as cats966 } from './maths/5eme/parallelogrammes/gen_966';
import { generate as gen967, CATEGORIES as cats967 } from './maths/5eme/parallelogrammes/gen_967';
import { generate as gen968, CATEGORIES as cats968 } from './maths/5eme/parallelogrammes/gen_968';
import { generate as gen969, CATEGORIES as cats969 } from './maths/5eme/parallelogrammes/gen_969';
import { generate as gen970, CATEGORIES as cats970 } from './maths/5eme/parallelogrammes/gen_970';
// --- statistiques (971-976) ---
import { generate as gen971, CATEGORIES as cats971 } from './maths/5eme/statistiques/gen_971';
import { generate as gen972, CATEGORIES as cats972 } from './maths/5eme/statistiques/gen_972';
import { generate as gen973, CATEGORIES as cats973 } from './maths/5eme/statistiques/gen_973';
import { generate as gen974, CATEGORIES as cats974 } from './maths/5eme/statistiques/gen_974';
import { generate as gen975, CATEGORIES as cats975 } from './maths/5eme/statistiques/gen_975';
import { generate as gen976, CATEGORIES as cats976 } from './maths/5eme/statistiques/gen_976';
// --- probabilites (166-1083) ---
import { generate as gen977, CATEGORIES as cats977 } from './maths/5eme/probabilites/gen_977';
import { generate as gen978, CATEGORIES as cats978 } from './maths/5eme/probabilites/gen_978';
import { generate as gen979, CATEGORIES as cats979 } from './maths/5eme/probabilites/gen_979';
import { generate as gen980, CATEGORIES as cats980 } from './maths/5eme/probabilites/gen_980';
// --- proportionnalite (171-1254) ---
import { generate as gen981, CATEGORIES as cats981 } from './maths/5eme/proportionnalite/gen_981';
import { generate as gen982, CATEGORIES as cats982 } from './maths/5eme/proportionnalite/gen_982';
import { generate as gen983, CATEGORIES as cats983 } from './maths/5eme/proportionnalite/gen_983';
import { generate as gen984, CATEGORIES as cats984 } from './maths/5eme/proportionnalite/gen_984';
import { generate as gen985, CATEGORIES as cats985 } from './maths/5eme/proportionnalite/gen_985';
import { generate as gen986, CATEGORIES as cats986 } from './maths/5eme/proportionnalite/gen_986';
import { generate as gen987, CATEGORIES as cats987 } from './maths/5eme/proportionnalite/gen_987';
// --- fonctions (175-995) ---
import { generate as gen993, CATEGORIES as cats993 } from './maths/5eme/fonctions/gen_993';
import { generate as gen994, CATEGORIES as cats994 } from './maths/5eme/fonctions/gen_994';
import { generate as gen995, CATEGORIES as cats995 } from './maths/5eme/fonctions/gen_995';
// --- pensee-informatique (996-1002) ---
import { generate as gen996, CATEGORIES as cats996 } from './maths/5eme/pensee-informatique/gen_996';
import { generate as gen997, CATEGORIES as cats997 } from './maths/5eme/pensee-informatique/gen_997';
import { generate as gen998, CATEGORIES as cats998 } from './maths/5eme/pensee-informatique/gen_998';
import { generate as gen999, CATEGORIES as cats999 } from './maths/5eme/pensee-informatique/gen_999';
import { generate as gen1000, CATEGORIES as cats1000 } from './maths/5eme/pensee-informatique/gen_1000';
import { generate as gen1001, CATEGORIES as cats1001 } from './maths/5eme/pensee-informatique/gen_1001';
import { generate as gen1002, CATEGORIES as cats1002 } from './maths/5eme/pensee-informatique/gen_1002';
// --- nombres-decimaux (596-1014) ---
import { generate as gen1005, CATEGORIES as cats1005 } from './maths/6eme/nombres-decimaux/gen_1005';
import { generate as gen1006, CATEGORIES as cats1006 } from './maths/6eme/nombres-decimaux/gen_1006';
import { generate as gen1007, CATEGORIES as cats1007 } from './maths/6eme/nombres-decimaux/gen_1007';
import { generate as gen1008, CATEGORIES as cats1008 } from './maths/6eme/nombres-decimaux/gen_1008';
import { generate as gen1009, CATEGORIES as cats1009 } from './maths/6eme/nombres-decimaux/gen_1009';
import { generate as gen1010, CATEGORIES as cats1010 } from './maths/6eme/nombres-decimaux/gen_1010';
import { generate as gen1011, CATEGORIES as cats1011 } from './maths/6eme/nombres-decimaux/gen_1011';
import { generate as gen1012, CATEGORIES as cats1012 } from './maths/6eme/nombres-decimaux/gen_1012';
import { generate as gen1013, CATEGORIES as cats1013 } from './maths/6eme/nombres-decimaux/gen_1013';
import { generate as gen1014, CATEGORIES as cats1014 } from './maths/6eme/nombres-decimaux/gen_1014';
// --- geometrie (653-1019) ---
import { generate as gen1015, CATEGORIES as cats1015 } from './maths/6eme/geometrie/gen_1015';
import { generate as gen1016, CATEGORIES as cats1016 } from './maths/6eme/geometrie/gen_1016';
import { generate as gen1017, CATEGORIES as cats1017 } from './maths/6eme/geometrie/gen_1017';
import { generate as gen1018, CATEGORIES as cats1018 } from './maths/6eme/geometrie/gen_1018';
import { generate as gen1019, CATEGORIES as cats1019 } from './maths/6eme/geometrie/gen_1019';
// --- longueurs (639-1024) ---
import { generate as gen1020, CATEGORIES as cats1020 } from './maths/6eme/longueurs/gen_1020';
import { generate as gen1021, CATEGORIES as cats1021 } from './maths/6eme/longueurs/gen_1021';
import { generate as gen1022, CATEGORIES as cats1022 } from './maths/6eme/longueurs/gen_1022';
import { generate as gen1023, CATEGORIES as cats1023 } from './maths/6eme/longueurs/gen_1023';
import { generate as gen1024, CATEGORIES as cats1024 } from './maths/6eme/longueurs/gen_1024';
// --- aires (644-1030) ---
import { generate as gen1025, CATEGORIES as cats1025 } from './maths/6eme/aires/gen_1025';
import { generate as gen1026, CATEGORIES as cats1026 } from './maths/6eme/aires/gen_1026';
import { generate as gen1027, CATEGORIES as cats1027 } from './maths/6eme/aires/gen_1027';
import { generate as gen1028, CATEGORIES as cats1028 } from './maths/6eme/aires/gen_1028';
import { generate as gen1029, CATEGORIES as cats1029 } from './maths/6eme/aires/gen_1029';
import { generate as gen1030, CATEGORIES as cats1030 } from './maths/6eme/aires/gen_1030';
// --- durée (650-1035) ---
import { generate as gen1031, CATEGORIES as cats1031 } from './maths/6eme/durée/gen_1031';
import { generate as gen1032, CATEGORIES as cats1032 } from './maths/6eme/durée/gen_1032';
import { generate as gen1033, CATEGORIES as cats1033 } from './maths/6eme/durée/gen_1033';
import { generate as gen1034, CATEGORIES as cats1034 } from './maths/6eme/durée/gen_1034';
import { generate as gen1035, CATEGORIES as cats1035 } from './maths/6eme/durée/gen_1035';
// --- ogd (675-1036) ---
import { generate as gen1036, CATEGORIES as cats1036 } from './maths/6eme/ogd/gen_1036';
// --- proportionnalite (171-1254) ---
import { generate as gen1037, CATEGORIES as cats1037 } from './maths/6eme/proportionnalite/gen_1037';
import { generate as gen1038, CATEGORIES as cats1038 } from './maths/6eme/proportionnalite/gen_1038';
// --- operations (691-1044) ---
import { generate as gen1039, CATEGORIES as cats1039 } from './maths/5eme/operations/gen_1039';
import { generate as gen1040, CATEGORIES as cats1040 } from './maths/5eme/operations/gen_1040';
import { generate as gen1041, CATEGORIES as cats1041 } from './maths/5eme/operations/gen_1041';
import { generate as gen1042, CATEGORIES as cats1042 } from './maths/5eme/operations/gen_1042';
import { generate as gen1043, CATEGORIES as cats1043 } from './maths/5eme/operations/gen_1043';
import { generate as gen1044, CATEGORIES as cats1044 } from './maths/5eme/operations/gen_1044';
// --- nombres-relatifs (702-1096) ---
import { generate as gen1045, CATEGORIES as cats1045 } from './maths/5eme/nombres-relatifs/gen_1045';
import { generate as gen1046, CATEGORIES as cats1046 } from './maths/5eme/nombres-relatifs/gen_1046';
// --- nombres-rationnels (923-1100) ---
import { generate as gen1047, CATEGORIES as cats1047 } from './maths/5eme/nombres-rationnels/gen_1047';
import { generate as gen1048, CATEGORIES as cats1048 } from './maths/5eme/nombres-rationnels/gen_1048';
import { generate as gen1049, CATEGORIES as cats1049 } from './maths/5eme/nombres-rationnels/gen_1049';
import { generate as gen1050, CATEGORIES as cats1050 } from './maths/5eme/nombres-rationnels/gen_1050';
import { generate as gen1051, CATEGORIES as cats1051 } from './maths/5eme/nombres-rationnels/gen_1051';
import { generate as gen1052, CATEGORIES as cats1052 } from './maths/5eme/nombres-rationnels/gen_1052';
import { generate as gen1053, CATEGORIES as cats1053 } from './maths/5eme/nombres-rationnels/gen_1053';
import { generate as gen1054, CATEGORIES as cats1054 } from './maths/5eme/nombres-rationnels/gen_1054';
import { generate as gen1055, CATEGORIES as cats1055 } from './maths/5eme/nombres-rationnels/gen_1055';
import { generate as gen1056, CATEGORIES as cats1056 } from './maths/5eme/nombres-rationnels/gen_1056';
import { generate as gen1057, CATEGORIES as cats1057 } from './maths/5eme/nombres-rationnels/gen_1057';
// --- puissances (926-1105) ---
import { generate as gen1058, CATEGORIES as cats1058 } from './maths/5eme/puissances/gen_1058';
import { generate as gen1059, CATEGORIES as cats1059 } from './maths/5eme/puissances/gen_1059';
// --- calcul-litteral (158-1233) ---
import { generate as gen1060, CATEGORIES as cats1060 } from './maths/5eme/calcul-litteral/gen_1060';
import { generate as gen1061, CATEGORIES as cats1061 } from './maths/5eme/calcul-litteral/gen_1061';
import { generate as gen1062, CATEGORIES as cats1062 } from './maths/5eme/calcul-litteral/gen_1062';
import { generate as gen1063, CATEGORIES as cats1063 } from './maths/5eme/calcul-litteral/gen_1063';
// --- reperage (944-1237) ---
import { generate as gen1064, CATEGORIES as cats1064 } from './maths/5eme/reperage/gen_1064';
import { generate as gen1065, CATEGORIES as cats1065 } from './maths/5eme/reperage/gen_1065';
// --- espace (183-1240) ---
import { generate as gen1066, CATEGORIES as cats1066 } from './maths/5eme/espace/gen_1066';
import { generate as gen1067, CATEGORIES as cats1067 } from './maths/5eme/espace/gen_1067';
import { generate as gen1068, CATEGORIES as cats1068 } from './maths/5eme/espace/gen_1068';
import { generate as gen1069, CATEGORIES as cats1069 } from './maths/5eme/espace/gen_1069';
// --- transformations (180-1121) ---
import { generate as gen1070, CATEGORIES as cats1070 } from './maths/5eme/transformations/gen_1070';
import { generate as gen1071, CATEGORIES as cats1071 } from './maths/5eme/transformations/gen_1071';
// --- angles (953-1075) ---
import { generate as gen1072, CATEGORIES as cats1072 } from './maths/5eme/angles/gen_1072';
import { generate as gen1073, CATEGORIES as cats1073 } from './maths/5eme/angles/gen_1073';
import { generate as gen1074, CATEGORIES as cats1074 } from './maths/5eme/angles/gen_1074';
import { generate as gen1075, CATEGORIES as cats1075 } from './maths/5eme/angles/gen_1075';
// --- triangles (954-1078) ---
import { generate as gen1076, CATEGORIES as cats1076 } from './maths/5eme/triangles/gen_1076';
import { generate as gen1077, CATEGORIES as cats1077 } from './maths/5eme/triangles/gen_1077';
import { generate as gen1078, CATEGORIES as cats1078 } from './maths/5eme/triangles/gen_1078';
// --- parallelogrammes (963-1080) ---
import { generate as gen1079, CATEGORIES as cats1079 } from './maths/5eme/parallelogrammes/gen_1079';
import { generate as gen1080, CATEGORIES as cats1080 } from './maths/5eme/parallelogrammes/gen_1080';
// --- probabilites (166-1083) ---
import { generate as gen1081, CATEGORIES as cats1081 } from './maths/5eme/probabilites/gen_1081';
import { generate as gen1082, CATEGORIES as cats1082 } from './maths/5eme/probabilites/gen_1082';
import { generate as gen1083, CATEGORIES as cats1083 } from './maths/5eme/probabilites/gen_1083';
// --- proportionnalite (171-1254) ---
import { generate as gen1084, CATEGORIES as cats1084 } from './maths/5eme/proportionnalite/gen_1084';
import { generate as gen1085, CATEGORIES as cats1085 } from './maths/5eme/proportionnalite/gen_1085';
// --- geometrie-plane (186-1244) ---
import { generate as gen1086, CATEGORIES as cats1086 } from './maths/4eme/geometrie-plane/gen_1086';
import { generate as gen1087, CATEGORIES as cats1087 } from './maths/4eme/geometrie-plane/gen_1087';
import { generate as gen1088, CATEGORIES as cats1088 } from './maths/4eme/geometrie-plane/gen_1088';
import { generate as gen1089, CATEGORIES as cats1089 } from './maths/4eme/geometrie-plane/gen_1089';
import { generate as gen1090, CATEGORIES as cats1090 } from './maths/4eme/geometrie-plane/gen_1090';
// --- nombres-relatifs (702-1096) ---
import { generate as gen1091, CATEGORIES as cats1091 } from './maths/4eme/nombres-relatifs/gen_1091';
import { generate as gen1092, CATEGORIES as cats1092 } from './maths/4eme/nombres-relatifs/gen_1092';
import { generate as gen1093, CATEGORIES as cats1093 } from './maths/4eme/nombres-relatifs/gen_1093';
import { generate as gen1094, CATEGORIES as cats1094 } from './maths/4eme/nombres-relatifs/gen_1094';
import { generate as gen1095, CATEGORIES as cats1095 } from './maths/4eme/nombres-relatifs/gen_1095';
import { generate as gen1096, CATEGORIES as cats1096 } from './maths/4eme/nombres-relatifs/gen_1096';
// --- nombres-rationnels (923-1100) ---
import { generate as gen1097, CATEGORIES as cats1097 } from './maths/4eme/nombres-rationnels/gen_1097';
import { generate as gen1098, CATEGORIES as cats1098 } from './maths/4eme/nombres-rationnels/gen_1098';
import { generate as gen1099, CATEGORIES as cats1099 } from './maths/4eme/nombres-rationnels/gen_1099';
import { generate as gen1100, CATEGORIES as cats1100 } from './maths/4eme/nombres-rationnels/gen_1100';
// --- puissances (926-1105) ---
import { generate as gen1101, CATEGORIES as cats1101 } from './maths/4eme/puissances/gen_1101';
import { generate as gen1102, CATEGORIES as cats1102 } from './maths/4eme/puissances/gen_1102';
import { generate as gen1103, CATEGORIES as cats1103 } from './maths/4eme/puissances/gen_1103';
import { generate as gen1104, CATEGORIES as cats1104 } from './maths/4eme/puissances/gen_1104';
import { generate as gen1105, CATEGORIES as cats1105 } from './maths/4eme/puissances/gen_1105';
// --- calcul-litteral (158-1233) ---
import { generate as gen1106, CATEGORIES as cats1106 } from './maths/4eme/calcul-litteral/gen_1106';
import { generate as gen1107, CATEGORIES as cats1107 } from './maths/4eme/calcul-litteral/gen_1107';
import { generate as gen1108, CATEGORIES as cats1108 } from './maths/4eme/calcul-litteral/gen_1108';
import { generate as gen1109, CATEGORIES as cats1109 } from './maths/4eme/calcul-litteral/gen_1109';
import { generate as gen1110, CATEGORIES as cats1110 } from './maths/4eme/calcul-litteral/gen_1110';
import { generate as gen1111, CATEGORIES as cats1111 } from './maths/4eme/calcul-litteral/gen_1111';
// --- reperage (944-1237) ---
import { generate as gen1112, CATEGORIES as cats1112 } from './maths/4eme/reperage/gen_1112';
import { generate as gen1113, CATEGORIES as cats1113 } from './maths/4eme/reperage/gen_1113';
import { generate as gen1114, CATEGORIES as cats1114 } from './maths/4eme/reperage/gen_1114';
// --- espace (183-1240) ---
import { generate as gen1115, CATEGORIES as cats1115 } from './maths/4eme/espace/gen_1115';
import { generate as gen1116, CATEGORIES as cats1116 } from './maths/4eme/espace/gen_1116';
import { generate as gen1117, CATEGORIES as cats1117 } from './maths/4eme/espace/gen_1117';
import { generate as gen1118, CATEGORIES as cats1118 } from './maths/4eme/espace/gen_1118';
// --- transformations (180-1121) ---
import { generate as gen1119, CATEGORIES as cats1119 } from './maths/4eme/transformations/gen_1119';
import { generate as gen1120, CATEGORIES as cats1120 } from './maths/4eme/transformations/gen_1120';
import { generate as gen1121, CATEGORIES as cats1121 } from './maths/4eme/transformations/gen_1121';
// --- geometrie-plane (186-1244) ---
import { generate as gen1122, CATEGORIES as cats1122 } from './maths/4eme/geometrie-plane/gen_1122';
import { generate as gen1123, CATEGORIES as cats1123 } from './maths/4eme/geometrie-plane/gen_1123';
import { generate as gen1124, CATEGORIES as cats1124 } from './maths/4eme/geometrie-plane/gen_1124';
// --- donnees (164-1248) ---
import { generate as gen1125, CATEGORIES as cats1125 } from './maths/4eme/donnees/gen_1125';
import { generate as gen1126, CATEGORIES as cats1126 } from './maths/4eme/donnees/gen_1126';
import { generate as gen1127, CATEGORIES as cats1127 } from './maths/4eme/donnees/gen_1127';
// --- proportionnalite (171-1254) ---
import { generate as gen1128, CATEGORIES as cats1128 } from './maths/4eme/proportionnalite/gen_1128';
import { generate as gen1129, CATEGORIES as cats1129 } from './maths/4eme/proportionnalite/gen_1129';
// --- nombres (136-1220) ---
import { generate as gen1213, CATEGORIES as cats1213 } from './maths/3eme/nombres/gen_1213';
import { generate as gen1214, CATEGORIES as cats1214 } from './maths/3eme/nombres/gen_1214';
import { generate as gen1215, CATEGORIES as cats1215 } from './maths/3eme/nombres/gen_1215';
import { generate as gen1216, CATEGORIES as cats1216 } from './maths/3eme/nombres/gen_1216';
import { generate as gen1217, CATEGORIES as cats1217 } from './maths/3eme/nombres/gen_1217';
import { generate as gen1218, CATEGORIES as cats1218 } from './maths/3eme/nombres/gen_1218';
import { generate as gen1219, CATEGORIES as cats1219 } from './maths/3eme/nombres/gen_1219';
import { generate as gen1220, CATEGORIES as cats1220 } from './maths/3eme/nombres/gen_1220';
// --- divisibilite (153-1224) ---
import { generate as gen1221, CATEGORIES as cats1221 } from './maths/3eme/divisibilite/gen_1221';
import { generate as gen1222, CATEGORIES as cats1222 } from './maths/3eme/divisibilite/gen_1222';
import { generate as gen1223, CATEGORIES as cats1223 } from './maths/3eme/divisibilite/gen_1223';
import { generate as gen1224, CATEGORIES as cats1224 } from './maths/3eme/divisibilite/gen_1224';
// --- calcul-litteral (158-1233) ---
import { generate as gen1225, CATEGORIES as cats1225 } from './maths/3eme/calcul-litteral/gen_1225';
import { generate as gen1226, CATEGORIES as cats1226 } from './maths/3eme/calcul-litteral/gen_1226';
import { generate as gen1227, CATEGORIES as cats1227 } from './maths/3eme/calcul-litteral/gen_1227';
import { generate as gen1228, CATEGORIES as cats1228 } from './maths/3eme/calcul-litteral/gen_1228';
import { generate as gen1229, CATEGORIES as cats1229 } from './maths/3eme/calcul-litteral/gen_1229';
import { generate as gen1230, CATEGORIES as cats1230 } from './maths/3eme/calcul-litteral/gen_1230';
import { generate as gen1231, CATEGORIES as cats1231 } from './maths/3eme/calcul-litteral/gen_1231';
import { generate as gen1232, CATEGORIES as cats1232 } from './maths/3eme/calcul-litteral/gen_1232';
import { generate as gen1233, CATEGORIES as cats1233 } from './maths/3eme/calcul-litteral/gen_1233';
// --- reperage (944-1237) ---
import { generate as gen1234, CATEGORIES as cats1234 } from './maths/3eme/reperage/gen_1234';
import { generate as gen1235, CATEGORIES as cats1235 } from './maths/3eme/reperage/gen_1235';
import { generate as gen1236, CATEGORIES as cats1236 } from './maths/3eme/reperage/gen_1236';
import { generate as gen1237, CATEGORIES as cats1237 } from './maths/3eme/reperage/gen_1237';
// --- espace (183-1240) ---
import { generate as gen1238, CATEGORIES as cats1238 } from './maths/3eme/espace/gen_1238';
import { generate as gen1239, CATEGORIES as cats1239 } from './maths/3eme/espace/gen_1239';
import { generate as gen1240, CATEGORIES as cats1240 } from './maths/3eme/espace/gen_1240';
// --- grandeurs (178-1245) ---
import { generate as gen1241, CATEGORIES as cats1241 } from './maths/3eme/grandeurs/gen_1241';
// --- geometrie-plane (186-1244) ---
import { generate as gen1242, CATEGORIES as cats1242 } from './maths/3eme/geometrie-plane/gen_1242';
import { generate as gen1243, CATEGORIES as cats1243 } from './maths/3eme/geometrie-plane/gen_1243';
import { generate as gen1244, CATEGORIES as cats1244 } from './maths/3eme/geometrie-plane/gen_1244';
// --- grandeurs (178-1245) ---
import { generate as gen1245, CATEGORIES as cats1245 } from './maths/3eme/grandeurs/gen_1245';
// --- donnees (164-1248) ---
import { generate as gen1246, CATEGORIES as cats1246 } from './maths/3eme/donnees/gen_1246';
import { generate as gen1247, CATEGORIES as cats1247 } from './maths/3eme/donnees/gen_1247';
import { generate as gen1248, CATEGORIES as cats1248 } from './maths/3eme/donnees/gen_1248';
// --- proportionnalite (171-1254) ---
import { generate as gen1249, CATEGORIES as cats1249 } from './maths/3eme/proportionnalite/gen_1249';
import { generate as gen1250, CATEGORIES as cats1250 } from './maths/3eme/proportionnalite/gen_1250';
import { generate as gen1251, CATEGORIES as cats1251 } from './maths/3eme/proportionnalite/gen_1251';
import { generate as gen1252, CATEGORIES as cats1252 } from './maths/3eme/proportionnalite/gen_1252';
import { generate as gen1253, CATEGORIES as cats1253 } from './maths/3eme/proportionnalite/gen_1253';
import { generate as gen1254, CATEGORIES as cats1254 } from './maths/3eme/proportionnalite/gen_1254';

const GENERATORS = {
    136: { generate: gen136, categories: cats136 },
    137: { generate: gen137, categories: cats137 },
    138: { generate: gen138, categories: cats138 },
    139: { generate: gen139, categories: cats139 },
    140: { generate: gen140, categories: cats140 },
    141: { generate: gen141, categories: cats141 },
    142: { generate: gen142, categories: cats142 },
    143: { generate: gen143, categories: cats143 },
    144: { generate: gen144, categories: cats144 },
    145: { generate: gen145, categories: cats145 },
    146: { generate: gen146, categories: cats146 },
    147: { generate: gen147, categories: cats147 },
    148: { generate: gen148, categories: cats148 },
    149: { generate: gen149, categories: cats149 },
    150: { generate: gen150, categories: cats150 },
    151: { generate: gen151, categories: cats151 },
    152: { generate: gen152, categories: cats152 },
    153: { generate: gen153, categories: cats153 },
    154: { generate: gen154, categories: cats154 },
    155: { generate: gen155, categories: cats155 },
    156: { generate: gen156, categories: cats156 },
    157: { generate: gen157, categories: cats157 },
    158: { generate: gen158, categories: cats158 },
    159: { generate: gen159, categories: cats159 },
    160: { generate: gen160, categories: cats160 },
    161: { generate: gen161, categories: cats161 },
    162: { generate: gen162, categories: cats162 },
    163: { generate: gen163, categories: cats163 },
    164: { generate: gen164, categories: cats164 },
    165: { generate: gen165, categories: cats165 },
    166: { generate: gen166, categories: cats166 },
    167: { generate: gen167, categories: cats167 },
    168: { generate: gen168, categories: cats168 },
    169: { generate: gen169, categories: cats169 },
    170: { generate: gen170, categories: cats170 },
    171: { generate: gen171, categories: cats171 },
    172: { generate: gen172, categories: cats172 },
    173: { generate: gen173, categories: cats173 },
    174: { generate: gen174, categories: cats174 },
    175: { generate: gen175, categories: cats175 },
    176: { generate: gen176, categories: cats176 },
    177: { generate: gen177, categories: cats177 },
    178: { generate: gen178, categories: cats178 },
    179: { generate: gen179, categories: cats179 },
    180: { generate: gen180, categories: cats180 },
    181: { generate: gen181, categories: cats181 },
    182: { generate: gen182, categories: cats182 },
    183: { generate: gen183, categories: cats183 },
    184: { generate: gen184, categories: cats184 },
    185: { generate: gen185, categories: cats185 },
    186: { generate: gen186, categories: cats186 },
    187: { generate: gen187, categories: cats187 },
    188: { generate: gen188, categories: cats188 },
    189: { generate: gen189, categories: cats189 },
    190: { generate: gen190, categories: cats190 },
    191: { generate: gen191, categories: cats191 },
    192: { generate: gen192, categories: cats192 },
    193: { generate: gen193, categories: cats193 },
    194: { generate: gen194, categories: cats194 },
    195: { generate: gen195, categories: cats195 },
    196: { generate: gen196, categories: cats196 },
    197: { generate: gen197, categories: cats197 },
    198: { generate: gen198, categories: cats198 },
    199: { generate: gen199, categories: cats199 },
    200: { generate: gen200, categories: cats200 },
    201: { generate: gen201, categories: cats201 },
    202: { generate: gen202, categories: cats202 },
    203: { generate: gen203, categories: cats203 },
    204: { generate: gen204, categories: cats204 },
    205: { generate: gen205, categories: cats205 },
    206: { generate: gen206, categories: cats206 },
    207: { generate: gen207, categories: cats207 },
    208: { generate: gen208, categories: cats208 },
    209: { generate: gen209, categories: cats209 },
    210: { generate: gen210, categories: cats210 },
    211: { generate: gen211, categories: cats211 },
    212: { generate: gen212, categories: cats212 },
    213: { generate: gen213, categories: cats213 },
    214: { generate: gen214, categories: cats214 },
    215: { generate: gen215, categories: cats215 },
    216: { generate: gen216, categories: cats216 },
    217: { generate: gen217, categories: cats217 },
    218: { generate: gen218, categories: cats218 },
    219: { generate: gen219, categories: cats219 },
    220: { generate: gen220, categories: cats220 },
    221: { generate: gen221, categories: cats221 },
    222: { generate: gen222, categories: cats222 },
    223: { generate: gen223, categories: cats223 },
    224: { generate: gen224, categories: cats224 },
    225: { generate: gen225, categories: cats225 },
    226: { generate: gen226, categories: cats226 },
    227: { generate: gen227, categories: cats227 },
    228: { generate: gen228, categories: cats228 },
    229: { generate: gen229, categories: cats229 },
    230: { generate: gen230, categories: cats230 },
    231: { generate: gen231, categories: cats231 },
    232: { generate: gen232, categories: cats232 },
    233: { generate: gen233, categories: cats233 },
    234: { generate: gen234, categories: cats234 },
    235: { generate: gen235, categories: cats235 },
    236: { generate: gen236, categories: cats236 },
    237: { generate: gen237, categories: cats237 },
    238: { generate: gen238, categories: cats238 },
    239: { generate: gen239, categories: cats239 },
    240: { generate: gen240, categories: cats240 },
    241: { generate: gen241, categories: cats241 },
    242: { generate: gen242, categories: cats242 },
    243: { generate: gen243, categories: cats243 },
    244: { generate: gen244, categories: cats244 },
    245: { generate: gen245, categories: cats245 },
    246: { generate: gen246, categories: cats246 },
    247: { generate: gen247, categories: cats247 },
    248: { generate: gen248, categories: cats248 },
    249: { generate: gen249, categories: cats249 },
    250: { generate: gen250, categories: cats250 },
    251: { generate: gen251, categories: cats251 },
    252: { generate: gen252, categories: cats252 },
    253: { generate: gen253, categories: cats253 },
    596: { generate: gen596, categories: cats596 },
    597: { generate: gen597, categories: cats597 },
    598: { generate: gen598, categories: cats598 },
    599: { generate: gen599, categories: cats599 },
    600: { generate: gen600, categories: cats600 },
    601: { generate: gen601, categories: cats601 },
    602: { generate: gen602, categories: cats602 },
    603: { generate: gen603, categories: cats603 },
    604: { generate: gen604, categories: cats604 },
    605: { generate: gen605, categories: cats605 },
    606: { generate: gen606, categories: cats606 },
    607: { generate: gen607, categories: cats607 },
    608: { generate: gen608, categories: cats608 },
    609: { generate: gen609, categories: cats609 },
    610: { generate: gen610, categories: cats610 },
    611: { generate: gen611, categories: cats611 },
    612: { generate: gen612, categories: cats612 },
    613: { generate: gen613, categories: cats613 },
    614: { generate: gen614, categories: cats614 },
    615: { generate: gen615, categories: cats615 },
    616: { generate: gen616, categories: cats616 },
    617: { generate: gen617, categories: cats617 },
    618: { generate: gen618, categories: cats618 },
    619: { generate: gen619, categories: cats619 },
    620: { generate: gen620, categories: cats620 },
    621: { generate: gen621, categories: cats621 },
    622: { generate: gen622, categories: cats622 },
    623: { generate: gen623, categories: cats623 },
    624: { generate: gen624, categories: cats624 },
    625: { generate: gen625, categories: cats625 },
    626: { generate: gen626, categories: cats626 },
    627: { generate: gen627, categories: cats627 },
    628: { generate: gen628, categories: cats628 },
    629: { generate: gen629, categories: cats629 },
    630: { generate: gen630, categories: cats630 },
    631: { generate: gen631, categories: cats631 },
    632: { generate: gen632, categories: cats632 },
    633: { generate: gen633, categories: cats633 },
    634: { generate: gen634, categories: cats634 },
    635: { generate: gen635, categories: cats635 },
    636: { generate: gen636, categories: cats636 },
    637: { generate: gen637, categories: cats637 },
    638: { generate: gen638, categories: cats638 },
    639: { generate: gen639, categories: cats639 },
    640: { generate: gen640, categories: cats640 },
    641: { generate: gen641, categories: cats641 },
    642: { generate: gen642, categories: cats642 },
    643: { generate: gen643, categories: cats643 },
    644: { generate: gen644, categories: cats644 },
    645: { generate: gen645, categories: cats645 },
    646: { generate: gen646, categories: cats646 },
    647: { generate: gen647, categories: cats647 },
    648: { generate: gen648, categories: cats648 },
    649: { generate: gen649, categories: cats649 },
    650: { generate: gen650, categories: cats650 },
    651: { generate: gen651, categories: cats651 },
    652: { generate: gen652, categories: cats652 },
    653: { generate: gen653, categories: cats653 },
    654: { generate: gen654, categories: cats654 },
    655: { generate: gen655, categories: cats655 },
    656: { generate: gen656, categories: cats656 },
    657: { generate: gen657, categories: cats657 },
    658: { generate: gen658, categories: cats658 },
    659: { generate: gen659, categories: cats659 },
    660: { generate: gen660, categories: cats660 },
    661: { generate: gen661, categories: cats661 },
    662: { generate: gen662, categories: cats662 },
    663: { generate: gen663, categories: cats663 },
    664: { generate: gen664, categories: cats664 },
    665: { generate: gen665, categories: cats665 },
    666: { generate: gen666, categories: cats666 },
    667: { generate: gen667, categories: cats667 },
    668: { generate: gen668, categories: cats668 },
    669: { generate: gen669, categories: cats669 },
    670: { generate: gen670, categories: cats670 },
    671: { generate: gen671, categories: cats671 },
    672: { generate: gen672, categories: cats672 },
    673: { generate: gen673, categories: cats673 },
    674: { generate: gen674, categories: cats674 },
    675: { generate: gen675, categories: cats675 },
    676: { generate: gen676, categories: cats676 },
    677: { generate: gen677, categories: cats677 },
    678: { generate: gen678, categories: cats678 },
    679: { generate: gen679, categories: cats679 },
    680: { generate: gen680, categories: cats680 },
    681: { generate: gen681, categories: cats681 },
    682: { generate: gen682, categories: cats682 },
    683: { generate: gen683, categories: cats683 },
    684: { generate: gen684, categories: cats684 },
    685: { generate: gen685, categories: cats685 },
    686: { generate: gen686, categories: cats686 },
    687: { generate: gen687, categories: cats687 },
    688: { generate: gen688, categories: cats688 },
    689: { generate: gen689, categories: cats689 },
    690: { generate: gen690, categories: cats690 },
    691: { generate: gen691, categories: cats691 },
    692: { generate: gen692, categories: cats692 },
    693: { generate: gen693, categories: cats693 },
    694: { generate: gen694, categories: cats694 },
    695: { generate: gen695, categories: cats695 },
    696: { generate: gen696, categories: cats696 },
    697: { generate: gen697, categories: cats697 },
    698: { generate: gen698, categories: cats698 },
    699: { generate: gen699, categories: cats699 },
    700: { generate: gen700, categories: cats700 },
    701: { generate: gen701, categories: cats701 },
    702: { generate: gen702, categories: cats702 },
    703: { generate: gen703, categories: cats703 },
    704: { generate: gen704, categories: cats704 },
    705: { generate: gen705, categories: cats705 },
    706: { generate: gen706, categories: cats706 },
    707: { generate: gen707, categories: cats707 },
    708: { generate: gen708, categories: cats708 },
    709: { generate: gen709, categories: cats709 },
    710: { generate: gen710, categories: cats710 },
    711: { generate: gen711, categories: cats711 },
    712: { generate: gen712, categories: cats712 },
    713: { generate: gen713, categories: cats713 },
    714: { generate: gen714, categories: cats714 },
    899: { generate: gen899, categories: cats899 },
    900: { generate: gen900, categories: cats900 },
    901: { generate: gen901, categories: cats901 },
    902: { generate: gen902, categories: cats902 },
    903: { generate: gen903, categories: cats903 },
    904: { generate: gen904, categories: cats904 },
    905: { generate: gen905, categories: cats905 },
    906: { generate: gen906, categories: cats906 },
    907: { generate: gen907, categories: cats907 },
    908: { generate: gen908, categories: cats908 },
    909: { generate: gen909, categories: cats909 },
    910: { generate: gen910, categories: cats910 },
    911: { generate: gen911, categories: cats911 },
    912: { generate: gen912, categories: cats912 },
    913: { generate: gen913, categories: cats913 },
    914: { generate: gen914, categories: cats914 },
    915: { generate: gen915, categories: cats915 },
    916: { generate: gen916, categories: cats916 },
    917: { generate: gen917, categories: cats917 },
    918: { generate: gen918, categories: cats918 },
    919: { generate: gen919, categories: cats919 },
    920: { generate: gen920, categories: cats920 },
    921: { generate: gen921, categories: cats921 },
    922: { generate: gen922, categories: cats922 },
    923: { generate: gen923, categories: cats923 },
    924: { generate: gen924, categories: cats924 },
    925: { generate: gen925, categories: cats925 },
    926: { generate: gen926, categories: cats926 },
    927: { generate: gen927, categories: cats927 },
    928: { generate: gen928, categories: cats928 },
    929: { generate: gen929, categories: cats929 },
    930: { generate: gen930, categories: cats930 },
    931: { generate: gen931, categories: cats931 },
    932: { generate: gen932, categories: cats932 },
    933: { generate: gen933, categories: cats933 },
    934: { generate: gen934, categories: cats934 },
    935: { generate: gen935, categories: cats935 },
    936: { generate: gen936, categories: cats936 },
    937: { generate: gen937, categories: cats937 },
    938: { generate: gen938, categories: cats938 },
    939: { generate: gen939, categories: cats939 },
    940: { generate: gen940, categories: cats940 },
    941: { generate: gen941, categories: cats941 },
    942: { generate: gen942, categories: cats942 },
    943: { generate: gen943, categories: cats943 },
    944: { generate: gen944, categories: cats944 },
    945: { generate: gen945, categories: cats945 },
    946: { generate: gen946, categories: cats946 },
    947: { generate: gen947, categories: cats947 },
    948: { generate: gen948, categories: cats948 },
    949: { generate: gen949, categories: cats949 },
    950: { generate: gen950, categories: cats950 },
    951: { generate: gen951, categories: cats951 },
    952: { generate: gen952, categories: cats952 },
    953: { generate: gen953, categories: cats953 },
    954: { generate: gen954, categories: cats954 },
    955: { generate: gen955, categories: cats955 },
    956: { generate: gen956, categories: cats956 },
    957: { generate: gen957, categories: cats957 },
    958: { generate: gen958, categories: cats958 },
    959: { generate: gen959, categories: cats959 },
    960: { generate: gen960, categories: cats960 },
    961: { generate: gen961, categories: cats961 },
    962: { generate: gen962, categories: cats962 },
    963: { generate: gen963, categories: cats963 },
    964: { generate: gen964, categories: cats964 },
    965: { generate: gen965, categories: cats965 },
    966: { generate: gen966, categories: cats966 },
    967: { generate: gen967, categories: cats967 },
    968: { generate: gen968, categories: cats968 },
    969: { generate: gen969, categories: cats969 },
    970: { generate: gen970, categories: cats970 },
    971: { generate: gen971, categories: cats971 },
    972: { generate: gen972, categories: cats972 },
    973: { generate: gen973, categories: cats973 },
    974: { generate: gen974, categories: cats974 },
    975: { generate: gen975, categories: cats975 },
    976: { generate: gen976, categories: cats976 },
    977: { generate: gen977, categories: cats977 },
    978: { generate: gen978, categories: cats978 },
    979: { generate: gen979, categories: cats979 },
    980: { generate: gen980, categories: cats980 },
    981: { generate: gen981, categories: cats981 },
    982: { generate: gen982, categories: cats982 },
    983: { generate: gen983, categories: cats983 },
    984: { generate: gen984, categories: cats984 },
    985: { generate: gen985, categories: cats985 },
    986: { generate: gen986, categories: cats986 },
    987: { generate: gen987, categories: cats987 },
    993: { generate: gen993, categories: cats993 },
    994: { generate: gen994, categories: cats994 },
    995: { generate: gen995, categories: cats995 },
    996: { generate: gen996, categories: cats996 },
    997: { generate: gen997, categories: cats997 },
    998: { generate: gen998, categories: cats998 },
    999: { generate: gen999, categories: cats999 },
    1000: { generate: gen1000, categories: cats1000 },
    1001: { generate: gen1001, categories: cats1001 },
    1002: { generate: gen1002, categories: cats1002 },
    1005: { generate: gen1005, categories: cats1005 },
    1006: { generate: gen1006, categories: cats1006 },
    1007: { generate: gen1007, categories: cats1007 },
    1008: { generate: gen1008, categories: cats1008 },
    1009: { generate: gen1009, categories: cats1009 },
    1010: { generate: gen1010, categories: cats1010 },
    1011: { generate: gen1011, categories: cats1011 },
    1012: { generate: gen1012, categories: cats1012 },
    1013: { generate: gen1013, categories: cats1013 },
    1014: { generate: gen1014, categories: cats1014 },
    1015: { generate: gen1015, categories: cats1015 },
    1016: { generate: gen1016, categories: cats1016 },
    1017: { generate: gen1017, categories: cats1017 },
    1018: { generate: gen1018, categories: cats1018 },
    1019: { generate: gen1019, categories: cats1019 },
    1020: { generate: gen1020, categories: cats1020 },
    1021: { generate: gen1021, categories: cats1021 },
    1022: { generate: gen1022, categories: cats1022 },
    1023: { generate: gen1023, categories: cats1023 },
    1024: { generate: gen1024, categories: cats1024 },
    1025: { generate: gen1025, categories: cats1025 },
    1026: { generate: gen1026, categories: cats1026 },
    1027: { generate: gen1027, categories: cats1027 },
    1028: { generate: gen1028, categories: cats1028 },
    1029: { generate: gen1029, categories: cats1029 },
    1030: { generate: gen1030, categories: cats1030 },
    1031: { generate: gen1031, categories: cats1031 },
    1032: { generate: gen1032, categories: cats1032 },
    1033: { generate: gen1033, categories: cats1033 },
    1034: { generate: gen1034, categories: cats1034 },
    1035: { generate: gen1035, categories: cats1035 },
    1036: { generate: gen1036, categories: cats1036 },
    1037: { generate: gen1037, categories: cats1037 },
    1038: { generate: gen1038, categories: cats1038 },
    1039: { generate: gen1039, categories: cats1039 },
    1040: { generate: gen1040, categories: cats1040 },
    1041: { generate: gen1041, categories: cats1041 },
    1042: { generate: gen1042, categories: cats1042 },
    1043: { generate: gen1043, categories: cats1043 },
    1044: { generate: gen1044, categories: cats1044 },
    1045: { generate: gen1045, categories: cats1045 },
    1046: { generate: gen1046, categories: cats1046 },
    1047: { generate: gen1047, categories: cats1047 },
    1048: { generate: gen1048, categories: cats1048 },
    1049: { generate: gen1049, categories: cats1049 },
    1050: { generate: gen1050, categories: cats1050 },
    1051: { generate: gen1051, categories: cats1051 },
    1052: { generate: gen1052, categories: cats1052 },
    1053: { generate: gen1053, categories: cats1053 },
    1054: { generate: gen1054, categories: cats1054 },
    1055: { generate: gen1055, categories: cats1055 },
    1056: { generate: gen1056, categories: cats1056 },
    1057: { generate: gen1057, categories: cats1057 },
    1058: { generate: gen1058, categories: cats1058 },
    1059: { generate: gen1059, categories: cats1059 },
    1060: { generate: gen1060, categories: cats1060 },
    1061: { generate: gen1061, categories: cats1061 },
    1062: { generate: gen1062, categories: cats1062 },
    1063: { generate: gen1063, categories: cats1063 },
    1064: { generate: gen1064, categories: cats1064 },
    1065: { generate: gen1065, categories: cats1065 },
    1066: { generate: gen1066, categories: cats1066 },
    1067: { generate: gen1067, categories: cats1067 },
    1068: { generate: gen1068, categories: cats1068 },
    1069: { generate: gen1069, categories: cats1069 },
    1070: { generate: gen1070, categories: cats1070 },
    1071: { generate: gen1071, categories: cats1071 },
    1072: { generate: gen1072, categories: cats1072 },
    1073: { generate: gen1073, categories: cats1073 },
    1074: { generate: gen1074, categories: cats1074 },
    1075: { generate: gen1075, categories: cats1075 },
    1076: { generate: gen1076, categories: cats1076 },
    1077: { generate: gen1077, categories: cats1077 },
    1078: { generate: gen1078, categories: cats1078 },
    1079: { generate: gen1079, categories: cats1079 },
    1080: { generate: gen1080, categories: cats1080 },
    1081: { generate: gen1081, categories: cats1081 },
    1082: { generate: gen1082, categories: cats1082 },
    1083: { generate: gen1083, categories: cats1083 },
    1084: { generate: gen1084, categories: cats1084 },
    1085: { generate: gen1085, categories: cats1085 },
    1086: { generate: gen1086, categories: cats1086 },
    1087: { generate: gen1087, categories: cats1087 },
    1088: { generate: gen1088, categories: cats1088 },
    1089: { generate: gen1089, categories: cats1089 },
    1090: { generate: gen1090, categories: cats1090 },
    1091: { generate: gen1091, categories: cats1091 },
    1092: { generate: gen1092, categories: cats1092 },
    1093: { generate: gen1093, categories: cats1093 },
    1094: { generate: gen1094, categories: cats1094 },
    1095: { generate: gen1095, categories: cats1095 },
    1096: { generate: gen1096, categories: cats1096 },
    1097: { generate: gen1097, categories: cats1097 },
    1098: { generate: gen1098, categories: cats1098 },
    1099: { generate: gen1099, categories: cats1099 },
    1100: { generate: gen1100, categories: cats1100 },
    1101: { generate: gen1101, categories: cats1101 },
    1102: { generate: gen1102, categories: cats1102 },
    1103: { generate: gen1103, categories: cats1103 },
    1104: { generate: gen1104, categories: cats1104 },
    1105: { generate: gen1105, categories: cats1105 },
    1106: { generate: gen1106, categories: cats1106 },
    1107: { generate: gen1107, categories: cats1107 },
    1108: { generate: gen1108, categories: cats1108 },
    1109: { generate: gen1109, categories: cats1109 },
    1110: { generate: gen1110, categories: cats1110 },
    1111: { generate: gen1111, categories: cats1111 },
    1112: { generate: gen1112, categories: cats1112 },
    1113: { generate: gen1113, categories: cats1113 },
    1114: { generate: gen1114, categories: cats1114 },
    1115: { generate: gen1115, categories: cats1115 },
    1116: { generate: gen1116, categories: cats1116 },
    1117: { generate: gen1117, categories: cats1117 },
    1118: { generate: gen1118, categories: cats1118 },
    1119: { generate: gen1119, categories: cats1119 },
    1120: { generate: gen1120, categories: cats1120 },
    1121: { generate: gen1121, categories: cats1121 },
    1122: { generate: gen1122, categories: cats1122 },
    1123: { generate: gen1123, categories: cats1123 },
    1124: { generate: gen1124, categories: cats1124 },
    1125: { generate: gen1125, categories: cats1125 },
    1126: { generate: gen1126, categories: cats1126 },
    1127: { generate: gen1127, categories: cats1127 },
    1128: { generate: gen1128, categories: cats1128 },
    1129: { generate: gen1129, categories: cats1129 },
    1213: { generate: gen1213, categories: cats1213 },
    1214: { generate: gen1214, categories: cats1214 },
    1215: { generate: gen1215, categories: cats1215 },
    1216: { generate: gen1216, categories: cats1216 },
    1217: { generate: gen1217, categories: cats1217 },
    1218: { generate: gen1218, categories: cats1218 },
    1219: { generate: gen1219, categories: cats1219 },
    1220: { generate: gen1220, categories: cats1220 },
    1221: { generate: gen1221, categories: cats1221 },
    1222: { generate: gen1222, categories: cats1222 },
    1223: { generate: gen1223, categories: cats1223 },
    1224: { generate: gen1224, categories: cats1224 },
    1225: { generate: gen1225, categories: cats1225 },
    1226: { generate: gen1226, categories: cats1226 },
    1227: { generate: gen1227, categories: cats1227 },
    1228: { generate: gen1228, categories: cats1228 },
    1229: { generate: gen1229, categories: cats1229 },
    1230: { generate: gen1230, categories: cats1230 },
    1231: { generate: gen1231, categories: cats1231 },
    1232: { generate: gen1232, categories: cats1232 },
    1233: { generate: gen1233, categories: cats1233 },
    1234: { generate: gen1234, categories: cats1234 },
    1235: { generate: gen1235, categories: cats1235 },
    1236: { generate: gen1236, categories: cats1236 },
    1237: { generate: gen1237, categories: cats1237 },
    1238: { generate: gen1238, categories: cats1238 },
    1239: { generate: gen1239, categories: cats1239 },
    1240: { generate: gen1240, categories: cats1240 },
    1241: { generate: gen1241, categories: cats1241 },
    1242: { generate: gen1242, categories: cats1242 },
    1243: { generate: gen1243, categories: cats1243 },
    1244: { generate: gen1244, categories: cats1244 },
    1245: { generate: gen1245, categories: cats1245 },
    1246: { generate: gen1246, categories: cats1246 },
    1247: { generate: gen1247, categories: cats1247 },
    1248: { generate: gen1248, categories: cats1248 },
    1249: { generate: gen1249, categories: cats1249 },
    1250: { generate: gen1250, categories: cats1250 },
    1251: { generate: gen1251, categories: cats1251 },
    1252: { generate: gen1252, categories: cats1252 },
    1253: { generate: gen1253, categories: cats1253 },
    1254: { generate: gen1254, categories: cats1254 },
};

/**
 * Génère un exercice aléatoire pour un attendu donné.
 * @param {number} attenduId - L'ID de l'attendu
 * @param {string} [typeExercice] - Type/catégorie spécifique ou null pour aléatoire
 * @returns {Object} Payload au format BanqueQuestion
 */
export const generateExercice = (attenduId, typeExercice) => {
    const entry = GENERATORS[attenduId];
    if (!entry) throw new Error(`Pas de générateur pour l'attendu ${attenduId}`);
    // Seuls le QCM et le vrai/faux nomment leurs erreurs (règle du 03/10/2026).
    return nettoyerErreurs(entry.generate(typeExercice));
};

/**
 * Liste des catégories/formats pour un attendu donné.
 * @param {number} attenduId
 * @returns {Array}
 */
export const getCategories = (attenduId) => {
    const entry = GENERATORS[attenduId];
    if (!entry) return [];
    return entry.categories;
};

/**
 * Indique si un attendu a un générateur enregistré.
 * @param {number} attenduId
 * @returns {boolean}
 */
export const hasGenerator = (attenduId) => Boolean(GENERATORS[attenduId]);

export default GENERATORS;
